import React from 'react';
import { Grid2, Paper, Typography, Avatar } from '@mui/material';
import { motion } from 'framer-motion';
import Student1Photo from '../assets/Student1.jpg'; // Replace with actual photo path
import Student2Photo from '../assets/Student2.jpg'; // Replace with actual photo path
import Student3Photo from '../assets/Student3.jpg'; // Replace with actual photo path

const CommentsSection = () => {
  // Animation variants for testimonials
  const testimonialVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { 
        duration: 0.6, 
        ease: 'easeOut',
        staggerChildren: 0.2, // Stagger the entrance of each testimonial
      } 
    }
  };

  const testimonialItemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  // Sample testimonials data
  const testimonials = [
    {
      name: "Nerissa Raforme ",
      photo: Student1Photo,
      quote: "From barely passing to scoring well above average, your guidance transformed my daughter’s confidence and performance. We’re truly grateful for your exceptional tutoring.",
    },
    {
      name: "Elle Jeremie",
      photo: Student2Photo,
      quote: "I enjoy your class very much. The way you explain the topic is very easy to understand. Not as complicated as the teacher at school. The one on one class helps me to improve my score.s. You have helped me have better confidence in myself.",
    },
    {
      name: "Brigitte Marianne",
      photo: Student3Photo,
      quote: "Maths Gem helped my daughter Jasmine by making it more fun, easily understood and improved her grade. Keep up the good work.",
    },
  ];

  return (
    <motion.div
      variants={testimonialVariants}
      initial="hidden"
      animate="visible"
      style={{ width: '100%', margin: '40px auto' }}
    >
      <Paper
        elevation={0}
        sx={{ 
          marginLeft: { md: 15, xs: 5 }, 
          marginRight: { md: 15, xs: 5 }, 
          padding: { md: 4, xs: 3 },
        }}
      >
        <Typography 
          variant="h4" 
          component="h2" 
          gutterBottom 
          sx={{ 
            textAlign: 'center', 
            fontWeight: 'bold', 
            color: '#2e7d32', 
            marginBottom: 4 
          }}
        >
          Testimonials
        </Typography>

        <Grid2 container spacing={3} justifyContent="center">
          {testimonials.map((testimonial, index) => (
            <Grid2 
              key={index} 
              size={{ xs: 12, sm: 6, md: 4 }} // 1 column on mobile, 2 on small screens, 3 on medium+
            >
              <motion.div variants={testimonialItemVariants}>
                <Paper
                  elevation={3}
                  sx={{ 
                    padding: 3, 
                    textAlign: 'center', 
                    backgroundColor: '#ffffff', 
                    borderRadius: 15 
                  }}
                >
                  {/* Student Photo */}
                  {/* <Avatar
                    src={testimonial.photo}
                    alt={testimonial.name}
                    sx={{ 
                      width: 100, 
                      height: 100, 
                      margin: '0 auto 16px', 
                      border: '3px solid #388e3c' 
                    }}
                  /> */}

                  {/* Student Testimonial */}
                  <Typography 
                    variant="body1" 
                    sx={{ 
                      fontStyle: 'italic', 
                      color: '#1b5e20', 
                      marginBottom: 2 
                    }}
                  >
                    "{testimonial.quote}"
                  </Typography>
                  <Typography 
                    variant="subtitle2" 
                    sx={{ 
                      fontWeight: 'bold', 
                      color: '#388e3c' 
                    }}
                  >
                    - {testimonial.name}
                  </Typography>
                </Paper>
              </motion.div>
            </Grid2>
          ))}
        </Grid2>
      </Paper>
    </motion.div>
  );
};

export default CommentsSection;